import util from "../util";
import $ from 'jquery';
import store from "../store";
import * as actions from "../actions";
import Renderer from '../canvas/renderer';

const ID = 'design-cfg';

const SUPPORTED_MENUS = ['menu-letter', 'menu-letter-landscape', 'menu-tabloid', 'menu-tabloid-landscape', 'menu-a4', 'menu-a4-landscape', 'menu-legal', 'menu-legal-landscape',
                        'letter', 'letter-landscape', 'tabloid', 'tabloid-landscape', 'a4', 'a4-landscape', 'legal', 'legal-landscape', 'custom'];
export function hasLayoutGuidesSupport(size) {
  if (!size) return false;

  return SUPPORTED_MENUS.indexOf(size) > -1 ||
    size.indexOf('kids-menu') > -1 ||
    size.indexOf('half-page-menu') > -1 ||
    size.indexOf('table-tent') > -1 ||
    size.indexOf('poster') > -1 ||
    size.indexOf('digital-menu-board') > -1 ||
    size.indexOf('sandwich board') > -1;
}

export function syncLayoutGuides() {
  const cfg = getLayoutGuides();
  store.dispatch(actions.showLayoutGuideProps(cfg));
  showLayoutGuides(cfg.guide, cfg.pageMargin, cfg.columnMargin);
}

export function moveLayoutGuidesInDom() {
  let $cfg = $('#' + ID);
  if ($cfg.length > 0) {
    $('#pages').append($cfg);
  }
}

export function storeLayoutGuides(guide, pageMargin, columnMargin) {
  let $cfg = $('#' + ID);
  if ($cfg.length === 0) {
    $cfg = $(`<div id="${ID}" style="display: none">{}</div>`);
    $('#pages').append($cfg);
  }

  let cfg = {};
  try { cfg = JSON.parse($cfg.html())} catch(ex) {}

  cfg.guide = guide;
  cfg.pageMargin = pageMargin;
  cfg.columnMargin = columnMargin;

  $cfg.html(JSON.stringify(cfg));
}

export function getLayoutGuides() {
  let $cfg = $(`#${ID}`);
  if ($cfg.length === 0) {
    return { guide: 0, pageMargin: .25, columnMargin: .25 }
  }

  let cfg = {};
  try { cfg = JSON.parse($cfg.html())} catch(ex) {}

  return {
    guide: cfg.guide === null || cfg.guide === undefined ? 0 : cfg.guide,
    pageMargin: cfg.pageMargin || .25,
    columnMargin: cfg.columnMargin || .25
  }
}

export function hideLayoutGuides() {
  setLayoutGuides(0, .1, .1);
}

export function setLayoutGuides(guide, pageMargin, columnMargin) {
  storeLayoutGuides(guide, pageMargin, columnMargin);
  showLayoutGuides(guide, pageMargin, columnMargin);
}

export function showLayoutGuides(guide, pageMargin, columnMargin) {
  const $pages = $('.page');
  $pages.find('.page-guides').remove();
  $pages.each(function(index) {
    $(this).append('<div class="guides page-guides"></div>');
    const isLastElement = index === $pages.length - 1;
    Renderer.getSafeZoneFromDesign(isLastElement);
  });

  if (guide === 0) return;

  addPageMargins($pages, pageMargin);
  addColumnMargins($pages, guide, pageMargin, columnMargin);
}

function addPageMargins($pages, margin) {
  const dims = util.getActiveDimensions();

  let horizontalMargin = 0;
  let verticalHeight = 0;
  let verticalMargin = 0;

  if (dims.unit === 'px') {
    horizontalMargin = util.pixelToPercent(margin, dims.width);
    verticalHeight = util.pixelToPercent(margin, dims.height);
    verticalMargin = util.pixelToPercent(margin, dims.height) + util.pixelToPercent(9, dims.height);
  } else {
    horizontalMargin = util.inchToPercent(margin, dims.width);
    verticalHeight = util.inchToPercent(margin, dims.height);
    verticalMargin = util.inchToPercent(margin, dims.height) + util.pixelToPercent(9, dims.height);
  }

  const content = `
    <div class="gd top" style="height: ${verticalHeight}%"></div>
    <div class="gd bottom" style="height: ${verticalHeight}%"></div>
    <div class="gd left" style="width: ${horizontalMargin}%; top: ${verticalMargin}%; bottom: ${verticalMargin}%;"></div>
    <div class="gd right" style="width: ${horizontalMargin}%; top: ${verticalMargin}%; bottom: ${verticalMargin}%;"></div>
  `;

  $pages.find('.page-guides').each(function() {
    $(this).append(content);
  });
}

function addColumnMargins($pages, guide, pageMargin, columnMargin) {
  const dims = util.getActiveDimensions();

  let verticalPageMargin = 0;
  let horizontalPageMargin = 0;
  let columnMarginPercent = 0;

  if (dims.unit === 'px') {
    verticalPageMargin = util.pixelToPercent(pageMargin, dims.height) + util.pixelToPercent(9, dims.height);
    horizontalPageMargin = util.pixelToPercent(pageMargin, dims.width);
    columnMarginPercent = util.pixelToPercent(columnMargin, dims.width);
  } else {
    verticalPageMargin = util.inchToPercent(pageMargin, dims.height) + util.pixelToPercent(9, dims.height);
    horizontalPageMargin = util.inchToPercent(pageMargin, dims.width);
    columnMarginPercent = util.inchToPercent(columnMargin, dims.width);
  }

  let content = '';

  function gd(styles) {
    return `<div class="gd cm" style="top: ${verticalPageMargin}%; bottom: ${verticalPageMargin}%; width: ${columnMarginPercent}%; ${styles || ''}"></div>`
  }

  const full = 100;
  const available = 100 - 2 * horizontalPageMargin;
  const margin = columnMarginPercent / 2;

  switch (guide) {
    case 1:
      content += gd(`left: ${(full / 2) - margin}%`);
      break;
    case 2:
      content += gd(`left: ${(horizontalPageMargin + available * 2 / 3) - (columnMarginPercent / 2)}%`);
      break;
    case 3:
      content += gd(`left: ${(horizontalPageMargin + available / 3) - (columnMarginPercent / 2)}%`);
      break;
    case 4:
      content += gd(`left: ${(horizontalPageMargin + available / 3) - (columnMarginPercent * 2 / 3)}%`);
      content += gd(`left: ${(horizontalPageMargin + available * 2 / 3) - (columnMarginPercent / 3)}%`);
      break;
    case 5:
      content += gd(`left: ${(horizontalPageMargin + available / 4) - (columnMarginPercent * 3 / 4)}%`);
      content += gd(`left: ${(horizontalPageMargin + available / 2) - (columnMarginPercent / 2)}%`);
      content += gd(`left: ${(horizontalPageMargin + available * 3 / 4) - (columnMarginPercent / 4)}%`);
      break;
  }

  $pages.find('.page-guides').each(function() {
    $(this).append(content);
  });
}
